import { Pipe, PipeTransform } from '@angular/core';
import { StatusService } from '../services/status.service';
import { inject } from '@angular/core';

@Pipe({
  name: 'statusClass',
  standalone: true
})
export class StatusClassPipe implements PipeTransform {
  private readonly statusService = inject(StatusService);

  transform(status: string | null | undefined): string {
    if (!status) {
      return 'status-default';
    }

    // First try to get the exact kanban status class
    const kanbanClass = this.statusService.getStatusClass(status);
    if (kanbanClass !== 'status-default') {
      return kanbanClass;
    }

    // Fallback to generic status classes for non-kanban statuses
    const statusLower = status.toLowerCase();
    if (statusLower.includes('accepted') || statusLower.includes('hired')) return 'status-success';
    if (statusLower.includes('rejected') || statusLower.includes('declined')) return 'status-danger';
    if (statusLower.includes('pending') || statusLower.includes('review')) return 'status-warning';
    return 'status-info';
  }
}
